export enum CustomerEnum {
  Fastweb = 'FAS',
  Terna = 'TER',
  Vus = 'VUS',
  SmartGenova = 'MOV',
  Cogesi = 'COG',
  Infratel = 'INF'
}
